//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionBuilder.js";
import "../Motion/Motion.LinkAttachmentData.js";
import "../no/Expression.js";
import "../no/SelectNXObject.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"AddTensioner",1,0],[1,"Attachment",0,"Motion.LinkAttachmentData",0],[0,"LayoutType",1,0],[0,"Name",1,0],[1,"NumTeeth",0,"Expression",0],[0,"PathSide",1,0],[0,"PivotPoint",1,"Point",0],[1,"Radius",0,"Expression",0],[1,"Sketch",0,"SelectNXObject",0],[0,"SliderDirection",1,"Direction",0],[0,"TensionerType",1,0]],[],[]];
SPLM.Motion.DiscreteDrivetrainLayoutBuilder = class extends SPLM.Motion.MotionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.DiscreteDrivetrainLayoutBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.DiscreteDrivetrainLayoutBuilder.LayoutTypeOption = Object.freeze({
    "Sprocket" : "Sprocket", "Wheel" : "Wheel", "Guide" : "Guide", "VibrationDamper" : "VibrationDamper"});

SPLM.Motion.DiscreteDrivetrainLayoutBuilder.PathSideOption = Object.freeze({
    "Inside" : "Inside", "Outside" : "Outside"});

SPLM.Motion.DiscreteDrivetrainLayoutBuilder.TensionerTypeOption = Object.freeze({
    "Pivot" : "Pivot", "Slider" : "Slider"});

export default SPLM;